/**
 * External dependencies
 */
export default class Preferences {
  constructor(cscom) {
    if (!(this instanceof Preferences)) {
      return new Preferences(cscom);
    }
    this.cscom = cscom;
  }

  getPreferences() {
    return this.cscom.req.get("/api/rest/talink/dashboard/preferences");
  }

  savePreferences(preferences) {
    return this.cscom.req
      .put("/api/rest/talink/dashboard/preferences", preferences)
      .then((result) => {
        return result;
      });
  }
}
